var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinearSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#091119",
    d: "M3.5 21A3.5 3.5 0 0 1 0 17.5v-14A3.5 3.5 0 0 1 3.5 0h14A3.5 3.5 0 0 1 21 3.5v14a3.5 3.5 0 0 1-3.5 3.5zM2.333 3.5v14A1.167 1.167 0 0 0 3.5 18.667h14a1.167 1.167 0 0 0 1.167-1.167v-14A1.167 1.167 0 0 0 17.5 2.333h-14A1.167 1.167 0 0 0 2.333 3.5zm11.675 11.8L14 15.166V5.834a1.167 1.167 0 0 1 2.325-.134l.008.136v9.332a1.167 1.167 0 0 1-2.326.136zm-4.667 0l-.007-.136v-7a1.167 1.167 0 0 1 2.326-.136l.007.136v7a1.167 1.167 0 0 1-2.326.136zm-4.666 0l-.008-.136V10.5a1.167 1.167 0 0 1 2.326-.137L7 10.5v4.666a1.167 1.167 0 0 1-2.326.136z",
    transform: "translate(-0.5 -0.5) translate(0.5 0.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearSquare);
export default __webpack_public_path__ + "static/media/Linear-Square.ef96b1482d5ec930876a824fb8e10174.svg";
export { ForwardRef as ReactComponent };